import { render } from "./Print3DCatalogPage.vue?vue&type=template&id=08128a62&scoped=true"
import script from "./Print3DCatalogPage.vue?vue&type=script&lang=js"
export * from "./Print3DCatalogPage.vue?vue&type=script&lang=js"

import "./Print3DCatalogPage.vue?vue&type=style&index=0&id=08128a62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08128a62"]])

export default __exports__